import { FC, PropsWithChildren } from "react";

const mainStyle = {
  height: "inherit",
};

export const FullWidthLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <>
      <main className="d-flex flex-column flex-root" style={mainStyle}>
        {children}
      </main>
    </>
  );
};

